module.exports = {
  "notificationUsage": {
    "name": "Notification interaction",
    "class": "usage",
    "properties": {
      "delivery_method": {
        "type": "string",
        "isOptional": true
      },
      "notification_origin": {
        "type": "string",
        "isOptional": true
      },
      "notification_template_id": "string",
      "notification_type": "string",
      "action": "string",
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "notification-station"
  },
  "notificationInteraction": {
    "name": "notification-interaction",
    "class": "interaction",
    "properties": {
      "notification-type-id": {
        "type": "string",
        "isOptional": true
      },
      "notification-origin-name": {
        "type": "string",
        "isOptional": true
      },
      "delivery-method": {
        "type": "string",
        "isOptional": true
      },
      "notification-template-id": {
        "type": "string",
        "isOptional": true
      },
      "totalNotificationsFetched": {
        "type": "number",
        "isOptional": true
      },
      "rank": {
        "type": "number",
        "isOptional": true
      },
      "action": "string",
      "screen": "string",
      "link": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "notification-station"
  },
  "browserNotificationsInteraction": {
    "namespace": "browser-notifications",
    "name": "browser-notifications-interaction",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string",
        "isOptional": true
      },
      "template": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    }
  },
  "SidebarInteraction": {
    "name": "sidebar-interaction",
    "class": "interaction",
    "properties": {
      "archive": {
        "type": "string",
        "isOptional": true
      },
      "filter": {
        "type": "string",
        "isOptional": true
      },
      "NotificationRangeFetched": {
        "type": "number",
        "isOptional": true
      },
      "TotalNotificationsFetched": {
        "type": "number",
        "isOptional": true
      },
      "Rank": {
        "type": "number",
        "isOptional": true
      },
      "notification_origin": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "screen": "string",
      "subscreen": "string",
      "count": {
        "type": "number",
        "isOptional": true
      },
      "deliveryMethod": {
        "type": "string",
        "isOptional": true
      },
      "notificationIds": {
        "type": "array",
        "isOptional": true
      },
      "sidebarTab": {
        "type": "string",
        "isOptional": true
      },
      "originalTab": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "notification-station"
  },
  "fireAlarm": {
    "name": "fire alarm usage",
    "class": "usage",
    "properties": {
      "currentApp": "string",
      "currentUrl": "string",
      "type": "string",
      "title": "string",
      "id": "number"
    },
    "namespace": "notification-station"
  },
  "userImpersonation": {
    "name": "user impersonation",
    "class": "usage",
    "properties": {
      "currentApp": "string",
      "currentUrl": "string"
    },
    "namespace": "notification-station"
  }
};